




































import {Component, Vue} from 'vue-property-decorator'
import {addOrderRemark} from "@/api/shopOrder";
import {Getter} from "vuex-class";
Component.registerHooks(['beforeRouteLeave']);

@Component({
    name: 'AddRemark',
})
export default class AddRemark extends Vue {
    @Getter companyId!: string
    params = {
        orderType: '', // 1:订货单 2:退货单
        companyId: '',
        orderId: '',
        orderRemark: '',
        currRouteId: ''
    }
    isRefresh = 0

    created () {
        this.params.companyId = this.companyId
        this.params.orderId = this.$route.query.orderId as string
        this.params.orderType = this.$route.query.orderType as string
        this.params.currRouteId = this.$route.query.currRouteId as string
    }

    beforeRouteLeave(to, from, next) {
        to.query.isRefresh = this.isRefresh
        next();
    }

    submitRemark () {
        if (!this.params.orderRemark) {
            return this.$toast('请输入备注信息')
        }
        addOrderRemark(this.params).then(() => {
            this.$toast.success({
                message: '添加备注成功',
                duration: 1000,
                onClose: () => {
                  setTimeout(()=>{
                    this.isRefresh = 1
                    this.$router.back()
                  },200)
                }
            })
        }).catch(() => {})
    }
}
